import { JObject } from "../../../../common/data/models";
import { pharmaciesPerGovernateChartDto } from "../../domain";



export const PharmaciesPerGovernateChartMapper = {

    fromJson(json? : Array<JObject>): pharmaciesPerGovernateChartDto {
        if (!json || !json.length) {
            return {
            //    total: {
            //     label: 
            //    },
               data: [],
               color: '#FFA726',
            };
        }
        return {
            color: '#FFA726',
            data: json.map(e => {
                    return {
                        name: e.label,
                        label: e.label,
                        value: e.value,
                    }
                }),
        };
    },
}
